import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDontBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDoAndDontBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 10v5a3 3 0 0 0 3 3h5.155v-1.5H5A1.5 1.5 0 0 1 3.5 15v-5zm8.155-6.5H15A1.5 1.5 0 0 1 16.5 5v5H18V5a3 3 0 0 0-3-3h-4.845zm8.592 9.2a.75.75 0 0 1 0 1.06l-3.278 3.278-.53.53-.53-.53-1.706-1.706a.75.75 0 0 1 1.06-1.06l1.176 1.175 2.747-2.747a.75.75 0 0 1 1.06 0M2.999 2.844a.75.75 0 0 1 1.06 0l1.27 1.27 1.27-1.27a.75.75 0 1 1 1.06 1.06l-1.27 1.27 1.27 1.27a.75.75 0 0 1-1.06 1.06l-1.27-1.27-1.27 1.27A.75.75 0 1 1 3 6.444l1.27-1.27L3 3.904a.75.75 0 0 1 0-1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDontBox20);
